(function( $, window, document, undefined) {
    var Modal = {
        init: function init(elem) {
            this.$modal = $( elem );
            this.$modalContainer = $( '.modal__container' );
            this.$body = $( 'body' );
            this.$btnOpen = $( '[data="open-modal"]' );
            this.$btnClose = $( '[data="close-modal"]' );
            this.$classActive = 'modal-active';
            this.$form = $( elem ).find( 'form' );
            this.$message = $( '.message-alert' );

            this.events();
            this.openModalUrl();
        },

        openModalUrl: function openModalUrl() {
            if ( window.location.search == '?openPop=pop' ) {
                this.openModal();
            }
        },

        events: function events() {
            this.$btnOpen.on( 'click', this.openModal.bind(this) );
            this.$modal.on( 'click', this.closeModal.bind(this) );
            this.$btnClose.on( 'click', this.closeModal.bind(this) );
            this.$modalContainer.on( 'click', this.stopClose.bind(this) );
            this.$form.submit( this.validate.bind(this) );
        },

        openModal: function openModal(event) {
            this.$body.addClass( this.$classActive );

            if ( event ) {
                event.preventDefault();
            }
        },

        closeModal: function closeModal(event) {
            this.$body.removeClass( this.$classActive );
            this.closeMessage();
        },

        stopClose: function stopClose(event) {
            event.stopPropagation();
        },

        validate: function validate() {
            var input = this.$modal.find('input')
              , msg = this.$message
            ;

            input.each( function(index, elem) {
                if ( !$( elem ).val() ) {
                    event.preventDefault();
                    msg.addClass( 'active' );
                    return;
                }
            });
        },

        closeMessage: function closeMessage() {
            this.$message.removeClass( 'active' );
        }
    };

    $.fn.modal = function() {
        var modalObj = Object.create( Modal );
        return modalObj.init(this);
    };

})( jQuery, window, document );
